module.exports = __webpack_public_path__ + "img/1w.75ef829d.svg";